export default __webpack_public_path__ + "static/media/ReportsWhiteIcon.67f59c03.svg";